export default {
  button_add_row_title: 'Add',
  button_copy_row_title: 'Copy',
  button_delete_row_title: 'Delete',
  button_duplicate_row_title: 'Duplicate',
  button_object_properties_title: ''
}
